"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_toastify_1 = require("react-toastify");
const snackbar_1 = require("../snackbar");
const useToast = () => {
    const notify = ({ toastProps, snackbarProps }) => {
        (0, react_toastify_1.toast)(({ closeToast }) => (0, jsx_runtime_1.jsx)(snackbar_1.Snackbar, { ...{ ...snackbarProps, closeToast } }), {
            ...toastProps,
            type: !['darker', 'badge'].includes(snackbarProps.variant)
                ? snackbarProps.variant
                : undefined,
        });
    };
    const position = react_toastify_1.toast.POSITION.TOP_RIGHT;
    const message = {
        success: (label, toastProps) => notify({
            snackbarProps: { label, variant: 'success' },
            toastProps: { ...toastProps, position, type: 'success' },
        }),
        error: (label, toastProps) => notify({
            snackbarProps: { label, variant: 'error' },
            toastProps: { ...toastProps, position, type: 'error' },
        }),
        warning: (label, toastProps) => notify({
            snackbarProps: { label, variant: 'warning' },
            toastProps: { ...toastProps, position, type: 'warning' },
        }),
        info: (label, toastProps) => notify({
            snackbarProps: { label, variant: 'info' },
            toastProps: { ...toastProps, position, type: 'info' },
        }),
    };
    return { notify, message };
};
exports.useToast = useToast;
exports.default = exports.useToast;
//# sourceMappingURL=use-toast.js.map